import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <img src="/images/logo-small.jpeg" alt="Royal Parcel" />
            <p>
              Your trusted neighborhood postal center in North Hollywood. We provide premium shipping, 
              mailbox, and business services — because you deserve to ship like royalty.
            </p>
            <div className="footer-social">
              <a href="https://www.facebook.com/profile.php?id=61587713590085" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
                </svg>
              </a>
              <a href="https://www.instagram.com/royalparcel111" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/>
                </svg>
              </a>
              <a href="https://www.yelp.com/biz/royal-parcel-north-hollywood" target="_blank" rel="noopener noreferrer" aria-label="Yelp">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"/>
                </svg>
              </a>
            </div>
          </div>

          <div className="footer-col">
            <h4>Quick Links</h4>
            <Link to="/">Home</Link>
            <Link to="/about">About Us</Link>
            <Link to="/services">Services</Link>
            <Link to="/contact">Contact</Link>
          </div>

          <div className="footer-col">
            <h4>Our Services</h4>
            <Link to="/services">Shipping & Receiving</Link>
            <Link to="/services">Private Mailboxes</Link>
            <Link to="/services">Notary Public</Link>
            <Link to="/services">Print & Copy</Link>
            <Link to="/services">Packing Services</Link>
          </div>

          <div className="footer-col">
            <h4>Contact</h4>
            <p>
              11104 Magnolia Blvd.<br />
              North Hollywood, CA 91601
            </p>
            <br />
            <p>
              <a href="tel:+18182993899">(818) 299-3899</a><br />
              <a href="mailto:royalparcelnoho@gmail.com">royalparcelnoho@gmail.com</a>
            </p>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} Royal Parcel Inc. All rights reserved. | The World Is Yours To Ship Around</p>
          <a
            href="https://softangeles.com"
            target="_blank"
            rel="noopener noreferrer"
            style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', marginTop: '14px', opacity: 0.9, fontSize: '15px', fontWeight: 500, textDecoration: 'none', color: '#ffffff' }}
          >
            <span>Powered by</span>
            <img src="https://softangeles.com/logo-wide.png" alt="SoftAngeles" style={{ height: '30px', width: 'auto' }} />
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
